module.exports = __webpack_public_path__ + "img/page_elus.1071086f.jpg";